<template>
  <div v-show="false" />
</template>

<script>
import {
  defineComponent,
  useMeta,
  ref,
  useContext,
} from '@nuxtjs/composition-api';
import { productGetters } from '@gemini-vsf/composables';

export default defineComponent({
  name: 'StructuredProductData',
  props: {
    product: {
      type: Object,
      required: true,
    },
    stockStatus: {
      type: String,
      default: '',
    },
  },
  head: {},
  setup(props) {
    const structuredProductData = ref();
    const {
      i18n: {
        localeProperties: { defaultCurrency },
      },
      $vsf,
    } = useContext();
    const { currency } = $vsf.$gemini.config;
    // eslint-disable-next-line prefer-destructuring
    const isAtLeastOneVariantInStock = props.product.variants.some(
      (variant) => variant.product.only_x_left_in_stock > 0
    );
    const stockStatus = isAtLeastOneVariantInStock
      ? 'https://schema.org/InStock'
      : 'https://schema.org/outOfStock';
    structuredProductData.value = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: props.product?.name,
      image: props.product?.image?.url || props.product?.thumbnail?.url,
      description: props.product?.description?.html.replaceAll('<BR/>', ' '),
      ...(props.product?.composition && {
        material: props.product?.composition,
      }),
      sku: props.product?.merchant_sku,
      offers: {
        '@type': 'Offer',
        price: productGetters.getFinalPrice(props.product),
        priceValidUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        ).toISOString(),
        availability: `${stockStatus}`,
        priceCurrency: currency ?? defaultCurrency,
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          merchantReturnDays: 30,
          refundType: 'FullRefund',
          returnShippingFeesPayer: 'Buyer',
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'IT',
          },
          shippingRate: {
            '@type': 'MonetaryAmount',
            currency: currency ?? defaultCurrency,
            value: 0,
          },
        },
      },
      ...(props.product?.brand_attribute?.label && {
        brand: {
          '@type': 'Brand',
          name: props.product?.brand_attribute?.label,
        },
      }),
    };

    useMeta(() => ({
      script: [
        {
          innerHTML: JSON.stringify(structuredProductData.value),
          type: 'application/ld+json',
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }));
  },
});
</script>
